/**
 * 消息的弹窗展示
 */
import React from 'react';
import { Icon } from 'antd';

import '../../../style/common/messagePanel.css';

import NoticeDialog from './NoticeDialog';
import messager from '../../ui/messager';

const messageType = {
    'remind': '提醒',
    'info': '消息',
    'warning': '警告',
    'hotspot': '热点'
}
class MessagePanel extends React.Component {

    state = {
        visible: true,
        detailVisible: false,
        info: {},
    }

    hidePanel = () => {
        this.setState({ visible: false });
    };

    detail = (info, e) => {
        if (info.type === 'hotspot') {
            this.setState({ info: info, detailVisible: true })
        } else {
            let type = info.type === 'remind' ? 'info' : info.type;
            messager.alert(info.content, info.title, type);
        }
    }
    
    hideDetailModal = () => {
        this.setState({ detailVisible: false });
    }

    render() {
        let messageList = this.props.messageList;
        if (messageList == null) messageList = [];
        let num = messageList.length;
        let visible = this.state.visible && num > 0;
        return (
            <div>
                <div className="message-panel" style={{ display: visible ? '' : 'none' }}>
                    <div className="message-title" >
                        <div className="icon"></div>
                        <div className="text">消息中心<span className="num">({num})</span></div>
                        <div className="message-btn">
                            <Icon type="close-circle" className="btn-icon" onClick={() => this.setState({ visible: false })} />
                        </div>
                    </div>
                    <div className="message-content">
                        <div>
                            {
                                messageList.map((item, index) => {
                                    return (
                                        <div className={item.roof ? "item roof" : "item"} key={index} onClick={this.detail.bind(this, item)} >
                                            <div className="text">{item.title}</div>
                                            <div className={"type " + item.type}>{messageType[item.type]}</div>
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </div>
                </div>
                <NoticeDialog
                    visible={this.state.detailVisible}
                    onCancel={this.hideDetailModal}
                    title={this.state.info.title}
                    content={this.state.info.content}
                />
            </div>
        )
    }
}
export default MessagePanel;